import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AppShell from './AppShell';

// BrowserRouter, not HashRouter: A2P 10DLC reviewers (and crawlers) cannot see
// content behind a "#" fragment, so every page needs a real path. This requires
// an SPA rewrite on the host — see DEPLOYMENT.md.
function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
